export const MuiFormControl = () => ({
  styleOverrides: {
    root: {
      width: '100%',
    },
  },
});
